export default __webpack_public_path__ + "static/media/test.00f5eb31.svg";